<script>
  /* global Global, DEV_ENV */
  import HeaderDefault from './HeaderDefault.svelte';
  import HeaderNew from './HeaderNew.svelte';
  import HeaderOld from './HeaderOld.svelte';
  import HeaderSharp from './HeaderSharp.svelte';
  import CookiesBar from '../ui-components/CookiesBar.svelte';

  export let page;
  export let lang = undefined;
  export let display = true;
  export let savePage = true;
  export let user = undefined;
  export let mode = undefined;

  let cookies = window.localStorage.getItem('cookies');

  function acceptCookies () {
    cookies = 'accepted';
    window.localStorage.setItem('cookies', cookies);
  }

  function rejectCookies () {
    cookies = 'rejected';
    window.localStorage.setItem('cookies', cookies);
  }

  if (Global.project.analytics.google && !DEV_ENV) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const f = document.getElementsByTagName('script')[0];
    const j = document.createElement('script');

    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${Global.project.analytics.google}`;

    f.parentNode.insertBefore(j, f);

    function gtag () {
      window.dataLayer.push(arguments);
    }

    if (cookies === 'accepted') {
      gtag('consent', 'update', {
        ad_storage: 'denied',
        analytics_storage: 'granted',
      });
    } else {
      gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
      });
    }
  }

  if (Global.project.analytics.facebook && !DEV_ENV) {
    if (!window.fbq) {
      window.fbq = function () {
        if (window.fbq.callMethod) {
          window.fbq.callMethod.apply(window.fbq, arguments);
        } else {
          window.fbq.queue.push(arguments);
        }
      };

      if (!window._fbq) {
        window._fbq = window.fbq;
      }

      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];

      const s = document.getElementsByTagName('script')[0];
      const t = document.createElement('script');

      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';

      s.parentNode.insertBefore(t, s);
    }

    window.fbq('init', Global.project.analytics.facebook);
    window.fbq('track', 'PageView');

    if (cookies === 'accepted') {
      window.fbq('consent', 'grant');
    }
  }

  const USER_PAGES = [
    {
      code: 'schedule-and-results',
      label: {
        cs: 'Rozpis a výsledky',
        en: 'Schedule and results',
      },
      color: 'purple',
    },
    {
      code: 'standings',
      label: {
        cs: 'Umístění',
        en: 'Standings',
      },
      color: 'blue',
    },
    {
      code: 'statistics',
      label: {
        cs: 'Statistiky',
        en: 'Statistics',
      },
      color: 'cyan',
    },
    {
      code: 'teams',
      label: {
        cs: 'Týmy',
        en: 'Teams',
      },
      color: 'green',
    },
    {
      code: 'fields',
      label: {
        cs: 'Hřiště',
        en: 'Fields',
      },
      color: 'yellow',
    },
    {
      code: 'tickets',
      label: {
        cs: 'Vstupenky',
        en: 'Tickets',
      },
      color: 'orange',
    },
    {
      code: 'history',
      label: {
        cs: 'Historie',
        en: 'History',
      },
      color: 'brown',
    },
  ].filter(page => Global.pages.includes(page.code));

  const ADMIN_PAGES = [
    {
      code: 'admin/upload/photo',
      icon: 'upload',
      label: {
        cs: 'Nahrát fotografii',
        en: 'Upload photo',
      },
      role: 'ROLE_ADMIN',
    },
    {
      code: 'admin/upload/image',
      icon: 'upload',
      label: {
        cs: 'Nahrát obrázek',
        en: 'Upload image',
      },
      role: 'ROLE_ADMIN',
    },
    {
      code: 'admin/upload/file',
      icon: 'upload',
      label: {
        cs: 'Nahrát soubor',
        en: 'Upload file',
      },
      role: 'ROLE_ADMIN',
    },
    {
      link: './api/update/all',
      icon: 'refresh',
      label: {
        cs: 'Aktualizovat vše',
        en: 'Update all',
      },
      role: 'ROLE_ADMIN',
    },
    {
      code: 'change-password',
      icon: 'lock',
      label: {
        cs: 'Změnit heslo',
        en: 'Change password',
      },
      role: 'ROLE_USER',
    },
    {
      code: 'logout',
      icon: 'logout',
      label: {
        cs: 'Odhlásit se',
        en: 'Logout',
      },
      role: 'ROLE_USER',
    },
  ];

  const projectStyle = Global.project.style;
</script>

{#if projectStyle === 'new'}
  <HeaderNew bind:page bind:lang bind:display bind:savePage bind:user bind:mode {USER_PAGES} {ADMIN_PAGES}/>
{:else if projectStyle === 'old'}
  <HeaderOld bind:page bind:lang bind:display bind:savePage bind:user bind:mode {USER_PAGES} {ADMIN_PAGES}/>
{:else if projectStyle === 'sharp'}
  <HeaderSharp bind:page bind:lang bind:display bind:savePage bind:user bind:mode {USER_PAGES} {ADMIN_PAGES}/>
{:else}
  <HeaderDefault bind:page bind:lang bind:display bind:savePage bind:user bind:mode {USER_PAGES} {ADMIN_PAGES}/>
{/if}

{#if !cookies}
  <CookiesBar onAccept={acceptCookies} onReject={rejectCookies} bind:lang/>
{/if}
